const colors = {
  white: '#ffffff',
  black: '#000000',
  slate: {
    1: '#fbfcfd',
    2: '#f8f9fa',
    3: '#f1f3f5',
    4: '#eceef0',
    5: '#e6e8eb',
    6: '#dfe3e6',
    7: '#d7dbdf',
    8: '#c1c8cd',
    9: '#889096',
    10: '#7e868c',
    11: '#687076',
    12: '#11181c',
  },
  indigo: {
    1: '#fdfdfe',
    2: '#f8faff',
    3: '#f0f4ff',
    4: '#e6edfe',
    5: '#d9e2fc',
    6: '#c6d4f9',
    7: '#aec0f5',
    8: '#8da4ef',
    9: '#3e63dd',
    10: '#3a5ccc',
    11: '#3451b2',
    12: '#101d46',
  },
  red: {
    1: '#fffcfc',
    2: '#fff8f8',
    3: '#ffefef',
    4: '#ffe5e5',
    5: '#fdd8d8',
    6: '#f9c6c6',
    7: '#f3aeaf',
    8: '#eb9091',
    9: '#e5484d',
    10: '#dc3d43',
    11: '#cd2b31',
    12: '#381316',
  },
  green: {
    1: '#fbfefc',
    2: '#f2fcf5',
    3: '#e9f9ee',
    4: '#ddf3e4',
    5: '#ccebd7',
    6: '#b4dfc4',
    7: '#92ceac',
    8: '#5bb98c',
    9: '#30a46c',
    10: '#299764',
    11: '#18794e',
    12: '#153226',
  },
  overlay: {
    1: '#00000003',
    2: '#00000007',
    3: '#0000000c',
    4: '#00000012',
    5: '#00000017',
    6: '#0000001d',
    7: '#00000024',
    8: '#00000038',
    9: '#00000070',
    10: '#0000007a',
    11: '#00000090',
    12: '#000000e8',
  },
};

const alias = {
  bg: colors.white,
  fg: colors.slate[12],
  light: colors.slate[2],
  layer: colors.overlay[9],
  shadow: colors.slate[4],
  subtle: colors.slate[11],
  danger: colors.red[9],
  dangerBack: colors.red[2],
  dangerNext: colors.red[10],
  primary: colors.indigo[9],
  primaryBack: colors.indigo[2],
  primaryNext: colors.indigo[10],
  success: colors.green[9],
  successBack: colors.green[2],
  successNext: colors.green[10],
  focusBg: colors.indigo[2],
};

const radii = {
  pill: '999px',
};

const space = {
  0: '0px',
  1: '8px',
  2: '12px',
  3: '16px',
  4: '20px',
  5: '24px',
  6: '32px',
  7: '40px',
  8: '80px',
};

const fonts = {
  sans: 'system-ui',
  mono: 'monospace',
};

const shadows = {
  all: `${space[0]} ${space[0]} ${space[0]} 1px ${alias.shadow}`,
  top: `${space[0]} -1px ${space[0]} ${space[0]} ${alias.shadow}`,
  left: `-1px ${space[0]} ${space[0]} ${space[0]} ${alias.shadow}`,
  right: `1px ${space[0]} ${space[0]} ${space[0]} ${alias.shadow}`,
  bottom: `${space[0]} 1px ${space[0]} ${space[0]} ${alias.shadow}`,
  x: `-1px ${space[0]} ${space[0]} ${space[0]} ${alias.shadow}, 1px ${space[0]} ${space[0]} ${space[0]} ${alias.shadow}`,
  y: `${space[0]} -1px ${space[0]} ${space[0]} ${alias.shadow}, ${space[0]} 1px ${space[0]} ${space[0]} ${alias.shadow}`,
  focusAlt: `${space[0]} ${space[0]} ${space[0]} 1px ${alias.bg}, ${space[0]} ${space[0]} ${space[0]} 2px ${alias.primary}`,
  focusOuter: `${space[0]} ${space[0]} ${space[0]} 1px ${alias.primary}`,
  focusInner: `inset ${space[0]} ${space[0]} ${space[0]} 1px ${alias.primary}`,
};

const dayTheme = {
  colors,
  alias,
  radii,
  space,
  fonts,
  shadows,
};

export default dayTheme;
